import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
export function Header() {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const isActive = (path: string) => {
    return location.pathname === path;
  };
  const navLinks = [{
    name: 'HOME',
    path: '/'
  }, {
    name: 'ABOUT',
    path: '/about'
  }, {
    name: 'CONTACT',
    path: '/contact'
  }];
  return <header className="fixed top-0 left-0 w-full bg-white/95 backdrop-blur-sm z-50 border-b border-gray-100" data-id="element-80">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-81">
        <div className="flex items-center justify-between h-20" data-id="element-82">
          {/* Logo */}
          <Link to="/" className="flex items-center group" data-id="element-83">
            <span className="text-2xl font-black tracking-tighter text-black" data-id="element-84">
              RAVEN<span className="text-slate-600" data-id="element-85">ADVISORS</span>.
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-86">
            {navLinks.map(link => <Link key={link.name} to={link.path} className={`text-sm font-bold tracking-wider transition-colors duration-200 ${isActive(link.path) ? 'text-slate-600' : 'text-gray-500 hover:text-black'}`} data-id="element-87">
                {link.name}
              </Link>)}
            <Link to="/get-offer" className="bg-slate-600 text-white px-6 py-2.5 text-sm font-bold tracking-wide hover:bg-black transition-colors" data-id="element-88">
              GET OFFER
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button className="md:hidden p-2 text-black" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label="Toggle menu" data-id="element-89">
            {isMenuOpen ? <X className="w-6 h-6" data-id="element-90" /> : <Menu className="w-6 h-6" data-id="element-91" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden absolute top-20 left-0 w-full bg-white border-b border-gray-100 p-6 shadow-xl" data-id="element-92">
          <nav className="flex flex-col gap-4" data-id="element-93">
            {navLinks.map(link => <Link key={link.name} to={link.path} onClick={() => setIsMenuOpen(false)} className={`text-lg font-bold tracking-wide ${isActive(link.path) ? 'text-slate-600' : 'text-black'}`} data-id="element-94">
                {link.name}
              </Link>)}
            <Link to="/get-offer" onClick={() => setIsMenuOpen(false)} className="bg-slate-600 text-white px-6 py-3 text-center text-sm font-bold tracking-wide hover:bg-black transition-colors mt-2" data-id="element-95">
              GET CASH OFFER
            </Link>
          </nav>
        </div>}
    </header>;
}